import React, { Component } from "react";
import AppForm from "../../partials/AppForm";
import AppInput from "../../partials/AppInput";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

export class CareerSearch extends Component {
  constructor(props) {
    super(props);

    const initialRoles = (props.roles && props.roles.length > 0 ? props.roles : []).map((r) => {
      const val = typeof r === "string" ? r : (r.jobRole || r.role || r.name || r.key || r.value || "");
      const lbl = typeof r === "string" ? r : (r.label || r.jobRole || r.role || r.name || val);
      return { key: val, label: lbl };
    }).filter(opt => opt.key && String(opt.key).trim() !== "-" && opt.label && String(opt.label).trim() !== "-");

    const initialLocations = (props.locations && props.locations.length > 0 ? props.locations : []).map((l) => {
      const val = typeof l === "string" ? l : (l.location || l.name || l.key || l.value || "");
      const lbl = typeof l === "string" ? l : (l.label || l.location || l.name || val);
      return { key: val, label: lbl };
    }).filter(opt => opt.key && String(opt.key).trim() !== "-" && opt.label && String(opt.label).trim() !== "-");

    let initialFields = [
      {
        type: "select",
        name: "role",
        label: "Role",
        placeholder: "Select",
        options: initialRoles,
        clearable: true,
      },
      {
        type: "select",
        name: "location",
        label: "Location",
        placeholder: "Select",
        options: initialLocations,
        clearable: true,
      },
    ];

    this.state = {
      fields: initialFields,
      formKey: Date.now(),
      dateRange: null,
    };
  }

  componentDidMount() {
    this.updateOptionsFromProps(this.props);

    const api = this.props.api || window.app?.api;
    if (api) {
      if (api.apiGetJobRoles) {
        api.apiGetJobRoles()
          .then((res) => {
            const list = this.extractList(res, "roles");
            if (list && list.length > 0) {
              let newFields = [...this.state.fields];
              let roleField = newFields.find((f) => f.name === "role");
              if (roleField) {
                roleField.options = list.map((r) => {
                  const val = typeof r === "string" ? r : (r.jobRole || r.role || r.name || r.key || r.value || "");
                  const lbl = typeof r === "string" ? r : (r.label || r.jobRole || r.role || r.name || val);
                  return { key: val, label: lbl };
                }).filter(opt => opt.key && String(opt.key).trim() !== "-" && opt.label && String(opt.label).trim() !== "-");
                this.setState({ fields: newFields });
              }
            }
          })
          .catch((err) => console.error(err));
      }

      if (api.apiGetJobLocations) {
        api.apiGetJobLocations()
          .then((res) => {
            const list = this.extractList(res, "locations");
            if (list && list.length > 0) {
              let newFields = [...this.state.fields];
              let locField = newFields.find((f) => f.name === "location");
              if (locField) {
                locField.options = list.map((l) => {
                  const val = typeof l === "string" ? l : (l.location || l.name || l.key || l.value || "");
                  const lbl = typeof l === "string" ? l : (l.label || l.location || l.name || val);
                  return { key: val, label: lbl };
                }).filter(opt => opt.key && String(opt.key).trim() !== "-" && opt.label && String(opt.label).trim() !== "-");
                this.setState({ fields: newFields });
              }
            }
          })
          .catch((err) => console.error(err));
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.roles !== this.props.roles ||
      prevProps.locations !== this.props.locations
    ) {
      this.updateOptionsFromProps(this.props);
    }
  }

  extractList = (res, key) => {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    const rawData = res.data !== undefined ? res.data : res;
    if (Array.isArray(rawData)) return rawData;
    if (rawData && typeof rawData === "object") {
      if (Array.isArray(rawData.items) && rawData.items.length > 0) {
        if (Array.isArray(rawData.items[0]?.records)) return rawData.items[0].records;
        return rawData.items;
      }
      if (key && Array.isArray(rawData[key])) return rawData[key];
      if (Array.isArray(rawData.roles)) return rawData.roles;
      if (Array.isArray(rawData.locations)) return rawData.locations;
      if (Array.isArray(rawData.records)) return rawData.records;
      if (Array.isArray(rawData.list)) return rawData.list;
      if (Array.isArray(rawData.data)) return rawData.data;
    }
    if (key && Array.isArray(res[key])) return res[key];
    if (Array.isArray(res.roles)) return res.roles;
    if (Array.isArray(res.locations)) return res.locations;
    if (Array.isArray(res.items)) return res.items;
    if (Array.isArray(res.records)) return res.records;
    if (Array.isArray(res.list)) return res.list;
    return [];
  };

  updateOptionsFromProps = (props) => {
    const { roles, locations } = props;
    let newFields = [...this.state.fields];

    if (roles && roles.length > 0) {
      let roleField = newFields.find((f) => f.name === "role");
      if (roleField) {
        roleField.options = roles.map((r) => {
          const val = typeof r === "string" ? r : (r.jobRole || r.role || r.name || r.key || r.value || "");
          const lbl = typeof r === "string" ? r : (r.label || r.jobRole || r.role || r.name || val);
          return { key: val, label: lbl };
        }).filter(opt => opt.key && String(opt.key).trim() !== "-" && opt.label && String(opt.label).trim() !== "-");
      }
    }

    if (locations && locations.length > 0) {
      let locField = newFields.find((f) => f.name === "location");
      if (locField) {
        locField.options = locations.map((l) => {
          const val = typeof l === "string" ? l : (l.location || l.name || l.key || l.value || "");
          const lbl = typeof l === "string" ? l : (l.label || l.location || l.name || val);
          return { key: val, label: lbl };
        }).filter(opt => opt.key && String(opt.key).trim() !== "-" && opt.label && String(opt.label).trim() !== "-");
      }
    }

    this.setState({ fields: newFields });
  };

  onSearch() {
    if (this.refs.form && this.refs.form.form.current) {
      let data = this.refs.form.form.current.getData();
      const { dateRange } = this.state;
      if (dateRange && dateRange.length === 2) {
        data.createdAtStartDate = dateRange[0].format("YYYY-MM-DD");
        data.createdAtEndDate = dateRange[1].format("YYYY-MM-DD");
      }
      this.props.onSearch && this.props.onSearch(data);
    }
  }

  clearTextData = () => {
    this.setState({
      fields: this.state.fields.map((field) => ({ ...field, value: "", defaultValue: "" })),
      formKey: Date.now(),
      dateRange: null,
    });

    if (this.refs.form && this.refs.form.form.current) {
      this.refs.form.form.current.reset();
    }

    const clearedData = {};
    this.state.fields.forEach((f) => {
      clearedData[f.name] = "";
    });

    this.props.onSearch && this.props.onSearch(clearedData);
  };

  render() {
    let { fields, formKey } = this.state;
    const { onAddNew } = this.props;

    return (
      <div className="card bg-white p-3 mb-4 pb-4 shadow-sm" style={{ borderRadius: "12px" }}>
        <AppForm className="row filter-row align-items-end" ref="form" key={formKey}>
          {fields.map((field, i) => (
            <div className="col-md-3 mb-2 position-relative" key={i}>
              <AppInput {...field}></AppInput>
            </div>
          ))}
          <div className="col-md-3 mb-2 position-relative">
            <div className="form-group has-top-label">
              <label className="form-label" style={{ fontSize: "14px", fontWeight: "500", color: "#16223e" }}>
                Created On
              </label>
              <RangePicker
                style={{ width: "100%", height: "42px", borderRadius: "8px" }}
                value={this.state.dateRange}
                onChange={(val) => this.setState({ dateRange: val })}
              />
            </div>
            <div
              className="position-absolute w-100 text-end"
              style={{ bottom: "-22px", right: "12px" }}
            >
              <span
                className="clear-all mb-0"
                style={{
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#16223e",
                  textDecoration: "underline",
                }}
                onClick={() => this.clearTextData()}
              >
                Clear All
              </span>
            </div>
          </div>

          <div className="col-md-2 mb-2">
            <div className="form-group">
              <button
                type="button"
                className="btn w-100"
                style={{ backgroundColor: '#f39c12', color: 'white', fontWeight: 'bold', height: '42px' }}
                onClick={() => this.onSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </AppForm>
      </div>
    );
  }
}

export default connect(CareerSearch);
